export default __webpack_public_path__ + "static/genossen-wohnen-e1adaa050bbe4df26de0b2542ba83239.jpg";